import { customElement, scss } from '../../core/ids-decorators';
import IdsEventsMixin from '../../mixins/ids-events-mixin/ids-events-mixin';
import IdsLocaleMixin from '../../mixins/ids-locale-mixin/ids-locale-mixin';

import styles from './ids-button-group-section.scss';
import IdsLayoutFlex from '../ids-layout-flex/ids-layout-flex';

const Base = IdsLocaleMixin(
  IdsEventsMixin(
    IdsLayoutFlex
  )
);

/**
 * IDS Button Group Section Component
 * @type {IdsButtonGroupSection}
 * @inherits IdsLayoutFlex
 * @mixes IdsEventsMixin
 * @mixes IdsLocaleMixin
 */
@customElement('ids-button-group-section')
@scss(styles)
export default class IdsButtonGroupSection extends Base {
  constructor() {
    super();
  }

  /**
   * Invoked each time the custom element is appended into a document-connected element.
   */
  connectedCallback() {
    super.connectedCallback();
    this.#attachEventHandlers();
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
  }

  /**
   * Return the attributes we handle as getters/setters
   * @returns {Array} The attributes in an array
   */
  static get attributes() {
    return [
      ...super.attributes
    ];
  }

  /**
   * Sets up event listeners
   * @private
   * @returns {void}
   */
  #attachEventHandlers() {}

  /**
   * Create the Template for the contents
   * @returns {string} The template
   */
  template(): string {
    return `<slot></slot>`;
  }
}
